module.exports = __webpack_public_path__ + "static/media/CancelledInvoice.6e2b52b9.png";